import React, { Component, Children } from 'react'
import { Row, Col } from 'hljd'

export default class LayoutRow extends Component {
  removeLayoutKey = obj =>
    Object.keys(obj).reduce((acc, key) => {
      if (isNaN(Number(key))) acc[key] = obj[key]
      return acc
    }, {})

  handleChildren = children => {
    return Children.map(children, (item, index) => {
      const { span, ...rest } = item.props
      return (
        <Col span={span || this.props[index]} {...rest}>
          {item.props.children}
        </Col>
      )
    })
  }

  render() {
    const { children, ...rest } = this.props
    return (
      <Row {...this.removeLayoutKey(rest)}>{this.handleChildren(children)}</Row>
    )
  }
}
